import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

export const Centered = styled.div`
  display: flex;
  justify-content: center;
`;
export const Error = styled.span`
  color: red;
  font-size: 14px;
`;

export const Buttons = styled(Button)`
  background-color: #FFA500;
  border: 1px;
  border-color:  #FFA500;
  border-radius: 5px;
  color: white;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  font-family: 'Nunito', sans-serif;
  height: 50px;
  letter-spacing: 1px;
  margin: 10px 0px;
  &:hover {
    background-color: #FFA500;
    border-color:  #FFA500;
  }
}
`;

export const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(1),
  },
  alert: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
  card: {
    minWidth: 275,
  },
  content: {
    display: 'flex',

  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  text: {
    textAlign: 'center',
  }
}));

